import { Link } from 'react-router-dom';
import { routes } from '@/config/routes';
import Container from '@/components/common/Container';
import { Typography } from 'antd/lib';
import { Button } from 'antd';

const NotFound: React.FC = () => {
    return (
        <Container>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '80vh',
                    textAlign: 'center',
                }}
            >
                <Typography.Title level={1} style={{ fontWeight: 700, fontSize: 70 }}>
                    404
                </Typography.Title>
                <Typography.Title level={4} style={{ marginBottom: 30, marginTop: 0 }}>
                    Page Not Found
                </Typography.Title>
                <Typography.Text>
                    The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
                </Typography.Text>
                <br />
                <Link to={routes.root}>
                    <Button
                        type="primary"
                        size="large"
                    >
                        Back to Dashboard
                    </Button>
                </Link>
            </div>
        </Container>
    );
};

export default NotFound;